import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import cc from 'classcat';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { NavBar } from 'components/NavBar';
import { useSearchParams } from 'hooks/useSearchParams';
import {
  useAccountsModalDispatch,
  useAccountsModalState
} from 'providers/AccountsModalProvider';
import {
  getForgotPasswordOpen,
  getForgotUsernameOpen
} from 'store/selectors/app-data';
import { WalletModal } from '../WalletModal';
import './index.less';

type Props = {
  children: ReactElement;
  closeModal: (arg0: React.UIEvent<HTMLElement, MouseEvent>) => void;
};

export const MobileLayout = (props: Props): ReactElement => {
  const history = useHistory();
  const modalState = useAccountsModalState();
  const { t } = useTranslation();
  const { updateAccountModal } = useAccountsModalDispatch();
  const searchParams = useSearchParams();
  const [rootPath, mainPath] = location.search.includes('=*')
    ? location.search.split('=*&')
    : location.search.replace(/\?|=%2A$/g, '').split('=%2A&');

  const activeMenu = rootPath.concat(':').concat(mainPath);
  const forgotPass = useSelector(getForgotPasswordOpen);
  const forgotUsername = useSelector(getForgotUsernameOpen);

  return (
    <div
      className={cc([
        'mobileLayoutContainer',
        {
          mobileLayout__container: forgotPass || forgotUsername,
          mobileLayout__container__br:
            SpringConfigs.SHOW_ADDITIONAL_CHECKBOX_FOR_LOGIN &&
            SpringConfigs.VERIFICATION_TYPE === 0,
          mobileLayout__scrollOnFullPage:
            SpringConfigs.GAMBLING_LiNKS || SpringConfigs.TERMS_AND_CONDITIONS
        }
      ])}
      id="accountModal__wrapper__Layout"
    >
      <WalletModal activeMenu={activeMenu} haveCancel={true} />
      <NavBar
        title={modalState.title || ''}
        goBack={
          modalState.hideBack
            ? undefined
            : () => {
                history.goBack();
              }
        }
        extra={
          modalState.extra ||
          (!searchParams.booking_id ? (
            <div
              data-testid="close-button"
              className="accountModal__closeButton"
              onClick={e => {
                props.closeModal(e);
                updateAccountModal({ class: '', hideBack: true });
              }}
            >
              {t('account.closeModal')}
            </div>
          ) : null)
        }
        isLogin={modalState.title === t('account.signUp')}
      />
      <div
        className={cc([
          'accountModal accountModal--mobile',
          {
            'accountModal--dark': searchParams['bet-history']
          }
        ])}
      >
        {props.children}
      </div>
      <div id={'fixed-footer'} className={modalState.class} />
    </div>
  );
};
